module.exports = __webpack_public_path__ + "static/img/15022C_1_C_20210404_LC.5c275c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15022C_1_C_20210404_LC.png
// module id = p+Hi
// module chunks = 0